export default __webpack_public_path__ + "static/person02-913c6bec4c1881546d68347d4ca72368.png";